import { bl_mlm_lineage_hdr_RowClass } from "../../../dbschema";
import { BaseContainerModel } from "../../base-container.model";


export class MlmLineageContainerModel extends BaseContainerModel {

    bl_mlm_lineage_hdr : bl_mlm_lineage_hdr_RowClass = new bl_mlm_lineage_hdr_RowClass();
}